import React, { useState, useEffect, useContext } from "react";
import "./DadosIniciais.css";
import LoginOrCreateAccount from "../../login/LoginOrCreateAccount";
import { useAuth } from "../../../services/context/AuthContext";
import useProfileData from "../../../hooks/userProfileData";
import { CarrinhoContext } from "../../../services/context/CarrinhoContext";

const DadosIniciais = ({ onNext }) => {
  const { user } = useAuth();
  const { profileData, loading, error, fetchProfileData } = useProfileData();
  const [loggedIn, setLoggedIn] = useState(false);

  // CarrinhoContext para checar se há livro físico
  const { carrinho } = useContext(CarrinhoContext);

  // Verifica se há algum item físico no carrinho
  const temLivroFisico = carrinho.some((item) => item.formato === "fisico");

  // Estados para armazenar endereço se o usuário precisar preencher
  const [endereco, setEndereco] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [cep, setCep] = useState("");

  useEffect(() => {
    if (user) {
      setLoggedIn(true);
      fetchProfileData(); // busca/atualiza dados do perfil
    } else {
      setLoggedIn(false);
    }
  }, [user]);

  // Preenche o formulário local caso já tenhamos endereço no perfil
  useEffect(() => {
    if (profileData) {
      if (profileData.endereco) setEndereco(profileData.endereco);
      if (profileData.numero) setNumero(profileData.numero);
      if (profileData.complemento) setComplemento(profileData.complemento);
      if (profileData.bairro) setBairro(profileData.bairro);
      if (profileData.cidade) setCidade(profileData.cidade);
      if (profileData.estado) setEstado(profileData.estado);
      if (profileData.cep) setCep(profileData.cep);
    }
  }, [profileData]);

  // Verifica se o endereço está (parcialmente) preenchido
  const jaTemEndereco =
    endereco && numero && bairro && cidade && estado && cep;

  // Quando o usuário confirma os dados (ou cria conta), chamamos onNext()
  const handleNext = () => {
    onNext();
  };

  // Renderização caso o usuário não esteja logado
  if (!loggedIn) {
    return (
      <div className="dados-iniciais">
        <LoginOrCreateAccount navBlock={true} onNext={handleNext} />
      </div>
    );
  }

  // Se o usuário está logado mas NÃO tem nenhum livro físico no carrinho,
  // apenas pedimos confirmação simples de dados como antes.
  if (!temLivroFisico) {
    return (
      <div className="dados-iniciais">
        <div className="confirmar-dados">
          <p>
            Você está logado como: <br />
            "<strong>{profileData?.nome}</strong>"
          </p>
          <p>Deseja prosseguir?</p>
          <button onClick={handleNext}>Confirmar dados</button>
        </div>
      </div>
    );
  }

  // Caso haja livro físico, precisamos checar endereço:
  // 1) Se já tem endereço preenchido, basta confirmar ou editar
  // 2) Se não tem, exibe um form para preencher
  const handleSubmitEndereco = (e) => {
    e.preventDefault();
    // Se quiser atualizar no backend, você chamaria aqui
    // algo como updateProfile({endereco, numero, ...}).
    // Mas se neste momento basta armazenar localmente,
    // já está no state. Então é só prosseguir.
    onNext();
  };

  return (
    <div className="dados-iniciais">
      <h2>Endereço para Entrega (Livro Físico)</h2>

      {/* Se já tiver endereço completo, peça apenas para confirmar */}
      {jaTemEndereco ? (
        <>
          <div className="confirmar-dados">
            <p>
              <strong>Seu endereço atual:</strong>
            </p>
            <p>
              {endereco}, nº {numero} <br />
              {complemento && <>Complemento: {complemento} <br /></>}
              {bairro} - {cidade}/{estado} <br />
              CEP: {cep}
            </p>

            <p>Está correto?</p>
            <button onClick={handleNext} style={{ marginRight: "10px" }}>
              Sim, prosseguir
            </button>
            <button onClick={() => {
              // se quiser "forçar" reedição, basta limpar o state ou exibir o formulário
              setEndereco("");
              setNumero("");
              setComplemento("");
              setBairro("");
              setCidade("");
              setEstado("");
              setCep("");
            }}>
              Editar endereço
            </button>
          </div>
        </>
      ) : (
        // Caso não tenha endereço preenchido, pede para preencher
        <form className="form-endereco" onSubmit={handleSubmitEndereco}>
          <div className="form-group">
            <label>Endereço</label>
            <input
              type="text"
              value={endereco}
              onChange={(e) => setEndereco(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Número</label>
            <input
              type="text"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Complemento</label>
            <input
              type="text"
              value={complemento}
              onChange={(e) => setComplemento(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Bairro</label>
            <input
              type="text"
              value={bairro}
              onChange={(e) => setBairro(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Cidade</label>
            <input
              type="text"
              value={cidade}
              onChange={(e) => setCidade(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Estado</label>
            <input
              type="text"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>CEP</label>
            <input
              type="text"
              value={cep}
              onChange={(e) => setCep(e.target.value)}
              required
            />
          </div>

          <button type="submit">Salvar e prosseguir</button>
        </form>
      )}
    </div>
  );
};

export default DadosIniciais;
